// Cache client-side dei tassi storici EUR-based (per la vista unificata dei
// bilanci multi-valuta). I tassi storici sono immutabili → cache aggressiva:
// memoria di processo + localStorage, mai invalidata.
import * as api from '../api.js'

const LS_KEY = 'gunsi_even_fx_v1'
const LS_MAX_DATES = 400 // bound sulla crescita del mirror LS

let mem = null // { [date]: rates }

function loadMem() {
  if (mem) return mem
  try {
    mem = JSON.parse(localStorage.getItem(LS_KEY)) ?? {}
  } catch {
    mem = {}
  }
  return mem
}

function persist() {
  try {
    const dates = Object.keys(mem)
    if (dates.length > LS_MAX_DATES) {
      // tieni le date più recenti (le più probabili da riusare)
      dates.sort()
      for (const d of dates.slice(0, dates.length - LS_MAX_DATES)) delete mem[d]
    }
    localStorage.setItem(LS_KEY, JSON.stringify(mem))
  } catch {}
}

// Tassi per una data (YYYY-MM-DD) → { USD: …, GBP: …, … } (base EUR).
// null se il fetch fallisce e non c'è cache.
export async function getRates(date) {
  const m = loadMem()
  if (m[date]) return m[date]
  try {
    const res = await api.getFxRates(date)
    if (res?.rates) {
      m[date] = res.rates
      persist()
      return res.rates
    }
  } catch {}
  return null
}

// Batch: { [date]: rates } per tutte le date richieste (dedupe, in parallelo).
// Le date senza tassi (fetch fallito) mancano dalla mappa.
export async function getRatesForDates(dates) {
  const unique = [...new Set(dates.filter(Boolean))]
  const out = {}
  await Promise.all(unique.map(async (d) => {
    const r = await getRates(d)
    if (r) out[d] = r
  }))
  return out
}

// Cross-rate via EUR (mirror di gunsi-core/currencies convert).
// null se mancano i tassi per una delle due valute.
export function convert(amount, fromCur, toCur, rates) {
  if (!Number.isFinite(amount)) return null
  if (!fromCur) fromCur = 'EUR'
  if (!toCur) toCur = 'EUR'
  if (fromCur === toCur) return amount
  if (!rates) return null
  if (fromCur === 'EUR') {
    const r = rates[toCur]
    return r ? amount * r : null
  }
  if (toCur === 'EUR') {
    const r = rates[fromCur]
    return r ? amount / r : null
  }
  const rFrom = rates[fromCur]
  const rTo = rates[toCur]
  return (rFrom && rTo) ? (amount / rFrom) * rTo : null
}
